import { useMemo } from "react";
import { calculateDeliveryPricing, formatPence } from "../services/pricing.js";
export function useDeliveryPricing(input) {
    return useMemo(() => {
        const result = calculateDeliveryPricing(input);
        return {
            ...result,
            formatted: {
                basePrice: formatPence(result.basePrice),
                distanceCharge: formatPence(result.distanceCharge),
                stopCharge: formatPence(result.stopCharge),
                weightCharge: formatPence(result.weightCharge),
                servicePrice: formatPence(result.servicePrice),
                serviceFee: formatPence(result.serviceFee),
                vatAmount: formatPence(result.vatAmount),
                customerTotal: formatPence(result.customerTotal),
            },
        };
    }, [input]);
}
//# sourceMappingURL=useDeliveryPricing.js.map